export const home = '/';
export const authorize = '/authorize';
export const login = '/login';
export const resetPassword = '/resetPassword';
